import * as Comp from './button-label.styles'

import { useButtonProps } from '../../hooks/use-button-props'

type TButtonLabelProps = {
  children: React.ReactNode
}

export function ButtonLabel({ children }: TButtonLabelProps) {
  const { variant, size, disabled } = useButtonProps()

  return (
    <Comp.Label
      variant={variant}
      size={size}
      hasDisabled={disabled}
      numberOfLines={1}
      ellipsizeMode="clip"
    >
      {children}
    </Comp.Label>
  )
}
